"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GameplayUtil = void 0;
const Gameplay_1 = require("./Gameplay");
const GameplayCategory_1 = require("./GameplayCategory");
const GameplayDifficulty_1 = require("./GameplayDifficulty");
/* eslint-disable require-jsdoc */
class GameplayUtil {
    static getAllGameplayDifinitions() {
        return [
            {
                title: "Numbers",
                description: "Enter the number you hear.",
                gameplay: Gameplay_1.Gameplay.ComposeTheBlankWithLanguageNumberChoicesGameplay001,
                difficulty: GameplayDifficulty_1.GameplayDifficulty.Easy,
                difficultyDivision: 1,
                category: GameplayCategory_1.GameplayCategory.Numbers
            },
            {
                title: "Image Recognition 1",
                description: "Select the image that matches the text prompt.",
                gameplay: Gameplay_1.Gameplay.FourImageChoicesGameplay002,
                difficulty: GameplayDifficulty_1.GameplayDifficulty.Easy,
                difficultyDivision: 1,
                category: GameplayCategory_1.GameplayCategory.ImageRecognition
            },
            {
                title: "Text with Character Choices",
                description: "Select the character that matches the text prompt.",
                gameplay: Gameplay_1.Gameplay.FourTextChoicesGameplay002,
                difficulty: GameplayDifficulty_1.GameplayDifficulty.Easy,
                difficultyDivision: 1,
                category: GameplayCategory_1.GameplayCategory.CharacterRecognition
            },
            {
                title: "Image Recognition 2",
                description: "Select the text choice that matches the image.",
                gameplay: Gameplay_1.Gameplay.ImageWithChoicesGameplay002,
                difficulty: GameplayDifficulty_1.GameplayDifficulty.Easy,
                difficultyDivision: 2,
                category: GameplayCategory_1.GameplayCategory.ImageRecognition
            },
            {
                title: "Video Recognition",
                description: "Select the choice that matches the video.",
                gameplay: Gameplay_1.Gameplay.VideoWithChoicesGameplay002,
                difficulty: GameplayDifficulty_1.GameplayDifficulty.Easy,
                difficultyDivision: 1,
                category: GameplayCategory_1.GameplayCategory.VideoRecognition
            },
            {
                title: "Audio Recognition 1",
                description: "Select the term that you hear.",
                gameplay: Gameplay_1.Gameplay.AudioWithChoicesGameplay001,
                difficulty: GameplayDifficulty_1.GameplayDifficulty.Medium,
                difficultyDivision: 1,
                category: GameplayCategory_1.GameplayCategory.AudioRecognition
            },
            {
                title: "Audio Recognition 4",
                description: "Select the audio clip that matches the text prompt.",
                gameplay: Gameplay_1.Gameplay.AudioWithChoicesGameplay002,
                difficulty: GameplayDifficulty_1.GameplayDifficulty.Medium,
                difficultyDivision: 3,
                category: GameplayCategory_1.GameplayCategory.AudioRecognition
            },
            {
                title: "Audio Recognition 2",
                description: "Select the image that corresponds to the audio.",
                gameplay: Gameplay_1.Gameplay.FourImageChoicesGameplay003,
                difficulty: GameplayDifficulty_1.GameplayDifficulty.Medium,
                difficultyDivision: 1,
                category: GameplayCategory_1.GameplayCategory.AudioRecognition
            },
            {
                title: "Audio Recognition 5",
                description: "Select the character that you hear.",
                gameplay: Gameplay_1.Gameplay.FourTextChoicesGameplay003,
                difficulty: GameplayDifficulty_1.GameplayDifficulty.Medium,
                difficultyDivision: 6,
                category: GameplayCategory_1.GameplayCategory.AudioRecognition
            },
            {
                title: "Audio Recognition 3",
                description: "Select the audio clip that matches the image.",
                gameplay: Gameplay_1.Gameplay.ImageWithChoicesGameplay003,
                difficulty: GameplayDifficulty_1.GameplayDifficulty.Medium,
                difficultyDivision: 2,
                category: GameplayCategory_1.GameplayCategory.AudioRecognition
            },
            {
                title: "Fill in the Blank 2",
                description: "Finish the translation with the missing term.",
                gameplay: Gameplay_1.Gameplay.TextWithChoicesGameplay001,
                difficulty: GameplayDifficulty_1.GameplayDifficulty.Medium,
                difficultyDivision: 5,
                category: GameplayCategory_1.GameplayCategory.FillInTheBlank
            },
            {
                title: "Fill in the Blank 1",
                description: "Complete the sentence with the correct term.",
                gameplay: Gameplay_1.Gameplay.TextWithChoicesGameplay002,
                difficulty: GameplayDifficulty_1.GameplayDifficulty.Medium,
                difficultyDivision: 4,
                category: GameplayCategory_1.GameplayCategory.FillInTheBlank
            },
            {
                title: "Sentence Formation 1",
                description: "Fill in the blanks to complete the sentence translation.",
                gameplay: Gameplay_1.Gameplay.FillTheBlankWithMultipleChoiceSelectionGameplay001,
                difficulty: GameplayDifficulty_1.GameplayDifficulty.Hard,
                difficultyDivision: 1,
                category: GameplayCategory_1.GameplayCategory.SentenceFormation
            },
            {
                title: "Sentence Formation 2",
                description: "Drag and drop choices to translate the sentence.",
                gameplay: Gameplay_1.Gameplay.MultipleChoiceSelectionGameplay001,
                difficulty: GameplayDifficulty_1.GameplayDifficulty.Hard,
                difficultyDivision: 2,
                category: GameplayCategory_1.GameplayCategory.SentenceFormation
            }
        ];
    }
}
exports.GameplayUtil = GameplayUtil;
